<template>
  <div class="showTemplate">
    <a-statistic-countdown
      :title="deadtitle"
      :value="deadline"
      style="margin-left: 50px; position: absolute; right: 130px; top: 10px"
      @finish="onFinish"
      v-if="timer_status"
    />

    <a-switch
      checked-children="刷新开启"
      un-checked-children="刷新关闭"
      :checked="timer_status"
      @change="changeTimerStatus"
      style="margin-left: 50px; position: absolute; right: 30px; top: 30px"
    />

    <div class="salesCard">
      <a-tabs
        default-active-key="1"
        :tabBarStyle="{
          display: 'flex',
          justifyContent: 'flex-start',
          position: 'relative',
        }"
      >
        <a-tab-pane tab="数据概览" key="1"> </a-tab-pane>
        <div class="extra-wrapper" slot="tabBarExtraContent">
          <div class="extra-item">
            <a @click="setTimeDay(0)" :class="timeday == '0' ? 'selected' : ''"
              >今日</a
            >
            <a
              @click="setTimeDay(-1)"
              :class="timeday == '-1' ? 'selected' : ''"
              >昨日</a
            >
            <a
              @click="setTimeDay(-3)"
              :class="timeday == '-3' ? 'selected' : ''"
              >近3天</a
            >
            <a
              @click="setTimeDay(-7)"
              :class="timeday == '-7' ? 'selected' : ''"
              >近7天</a
            >
            <a @click="setTimeDay(1)" :class="timeday == '1' ? 'selected' : ''"
              >本月</a
            >
            <a @click="setTimeDay(2)" :class="timeday == '2' ? 'selected' : ''"
              >上月</a
            >
          </div>
          <a-range-picker
            :value="range_date"
            @change="onTimeChange"
            class="filterItem"
            showToday
            :placeholder="['开始时间', '结束时间']"
          />
        </div>
      </a-tabs>
      <a-spin :spinning="toploading" tip="加载中...">
        <a-row :gutter="24">
          <a-col :sm="24" :md="12" :xl="4" :style="{ marginBottom: '10px' }">
            <div class="ant-card">
              <div class="ant-card-body" style="padding: 20px 24px 8px">
                <div class="acss-79elbk">
                  <div class="acss-14lc1cu">
                    <div class="acss-qdes8r"></div>
                    <div class="acss-1odwksc">
                      <div class="acss-1qoci3j">
                        <span>消耗（元）</span>
                        <span class="acss-18kfphl">
                          <a-icon type="question-circle" />
                        </span>
                      </div>
                      <div class="text-2xl font-bold">
                        <span>¥ {{ report.stat_cost || '0.00' }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="acss-1fpsglh">
                    <div class="acss-eji7bv">
                      <span class="acss-1x0bxe0">本月</span>
                      <span class="acss-72p16p"
                        >￥{{ report.month_stat_cost }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :sm="24" :md="12" :xl="4" :bordered="false">
            <div class="ant-card">
              <div class="ant-card-body" style="padding: 20px 24px 8px">
                <div class="acss-79elbk">
                  <div class="acss-14lc1cu">
                    <div class="acss-qdes8r"></div>
                    <div class="acss-1odwksc">
                      <div class="acss-1qoci3j">
                        <span>整体支付ROI</span>
                        <span class="acss-18kfphl"
                          ><a-icon type="question-circle" />
                        </span>
                      </div>
                      <div class="text-2xl font-bold">
                        <span>{{
                          report.total_prepay_and_pay_order_roi2 || '0'
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="acss-1fpsglh">
                    <div class="acss-eji7bv">
                      <span class="acss-1x0bxe0">本月</span>
                      <span class="acss-72p16p">{{
                        report.month_total_prepay_and_pay_order_roi2 || '-'
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :sm="24" :md="12" :xl="4" :bordered="false">
            <div class="ant-card">
              <div class="ant-card-body" style="padding: 20px 24px 8px">
                <div class="acss-79elbk">
                  <div class="acss-14lc1cu">
                    <div class="acss-qdes8r"></div>
                    <div class="acss-1odwksc">
                      <div class="acss-1qoci3j">
                        <span>整体成交金额</span>
                        <span class="acss-18kfphl"
                          ><a-icon type="question-circle" />
                        </span>
                      </div>
                      <div class="text-2xl font-bold">
                        <span
                          >¥
                          {{
                            report.total_pay_order_gmv_for_roi2 || '0.00'
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="acss-1fpsglh">
                    <div class="acss-eji7bv">
                      <span class="acss-1x0bxe0">本月</span>
                      <span class="acss-72p16p"
                        >￥{{ report.month_total_pay_order_gmv_for_roi2 }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :sm="24" :md="12" :xl="4" :bordered="false">
            <div class="ant-card">
              <div class="ant-card-body" style="padding: 20px 24px 8px">
                <div class="acss-79elbk">
                  <div class="acss-14lc1cu">
                    <div class="acss-qdes8r"></div>
                    <div class="acss-1odwksc">
                      <div class="acss-1qoci3j">
                        <span>整体成交订单数</span>
                        <span class="acss-18kfphl"
                          ><a-icon type="question-circle" />
                        </span>
                      </div>
                      <div class="text-2xl font-bold">
                        <span>{{
                          report.total_pay_order_count_for_roi2 || '0'
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="acss-1fpsglh">
                    <div class="acss-eji7bv">
                      <span class="acss-1x0bxe0">本月</span>
                      <span class="acss-72p16p">{{
                        report.month_total_pay_order_count_for_roi2
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :sm="24" :md="12" :xl="4" :bordered="false">
            <div class="ant-card">
              <div class="ant-card-body" style="padding: 20px 24px 8px">
                <div class="acss-79elbk">
                  <div class="acss-14lc1cu">
                    <div class="acss-qdes8r"></div>
                    <div class="acss-1odwksc">
                      <div class="acss-1qoci3j">
                        <span>整体成交订单成本</span>
                        <span class="acss-18kfphl"
                          ><a-icon type="question-circle" />
                        </span>
                      </div>
                      <div class="text-2xl font-bold">
                        <span>{{
                          report.total_cost_per_pay_order_for_roi2 || '0'
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="acss-1fpsglh">
                    <div class="acss-eji7bv">
                      <span class="acss-1x0bxe0">本月</span>
                      <span class="acss-72p16p">{{
                        report.month_total_cost_per_pay_order_for_roi2
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :sm="24" :md="12" :xl="4" :bordered="false">
            <div class="ant-card">
              <div class="ant-card-body" style="padding: 20px 24px 8px">
                <div class="acss-79elbk">
                  <div class="acss-14lc1cu">
                    <div class="acss-qdes8r"></div>
                    <div class="acss-1odwksc">
                      <div class="acss-1qoci3j">
                        <span>整体成交智能优惠券金额</span>
                        <span class="acss-18kfphl"
                          ><a-icon type="question-circle" />
                        </span>
                      </div>
                      <div class="text-2xl font-bold">
                        <span
                          >¥
                          {{
                            report.total_pay_order_coupon_amount_for_roi2 ||
                            '0.00'
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="acss-1fpsglh">
                    <div class="acss-eji7bv">
                      <span class="acss-1x0bxe0">本月</span>
                      <span class="acss-72p16p"
                        >￥{{
                          report.month_total_pay_order_coupon_amount_for_roi2
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </a-spin>
    </div>

    <div class="tableWapper">
      <a-tabs
        default-active-key="1"
        :tabBarStyle="{ display: 'flex', justifyContent: 'flex-start' }"
      >
        <a-tab-pane key="1" tab="全部计划"></a-tab-pane>
      </a-tabs>
      <div></div>

      <div v-if="tableKey == '1' || tableKey == '4'">
        <Action
          ref="action"
          v-if="selectedRowKeys.length > 0"
          :selectedRowKeys="selectedRowKeys"
          :advertiser_id="advertiser_id"
          :dataMap="dataMap"
          @clearSelect="clearSelect"
        ></Action>
        <div class="filterCondition" style="padding: 0px 5px">
          <a-space>
            <a-radio-group
              default-value="a"
              v-model="smart_bid_type"
              button-style="solid"
              @change="handletargetChange"
            >
              <a-radio-button value="SMART_BID_CONSERVATIVE">
                放量投放（起量快）
              </a-radio-button>
              <a-radio-button value="SMART_BID_CUSTOM">
                控成本投放
              </a-radio-button>
            </a-radio-group>

            <a-input-search
              v-model="order_id"
              :allowClear="true"
              style="width: 250px; margin-left: 0px"
              placeholder="计划ID/名称"
              enter-button
              @search="onSearchKey"
            />

            <a-select
              v-model="status"
              style="width: 140px"
              @change="handleChange"
              placeholder="全部计划状态"
            >
              <a-select-option
                v-for="(item, index) in statusData"
                :key="index"
                :value="item.value"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-space>
        </div>
        <a-spin :spinning="spinning" tip="加载中...">
          <div
            class="scroll-tabox"
            style="position: relative; padding-bottom: 50px"
          >
            <a-table
              ref="inOrderTable"
              :columns="columns"
              :data-source="data"
              :pagination="pagination"
              :sortDirections="['descend', 'ascend', '']"
              @change="handleTableChange"
              :rowKey="(record) => record.ad_info.id"
              :rowSelection="{
                selectedRowKeys,
                onChange: onSelectChange,
              }"
              :scroll="{ x: 2000 }"
            >
              <div slot="ad" class="aweme-right" slot-scope="text">
                <div>
                  <a-tooltip placement="top" :title="text.ad_info.name">
                    <div class="aweme-title" @click="getDetail(text)">
                      {{ text.ad_info.name }}
                    </div>
                  </a-tooltip>
                </div>
                
                <div>
                  <span
                    style="color: #597ef7; cursor: pointer;"
                    @click="settk(text)"
                    >调控监控</span
                  > 
                </div>
                
                <div style="display: flex;margin-top: 10px;">
                  <div>
                    <a-switch
                      size="small"
                      :checked="
                        text.ad_info.opt_status == 'ENABLE' ? true : false
                      "
                      :loading="switchloading"
                      @change="onSwitchChange(text)"
                    />
                  </div>
                  <div style="margin-left: 5px">
                    <div class="small">
                      创建时间:{{ text.ad_info.create_time }}
                    </div>
                    <div class="small">
                      ID:{{ text.ad_info.id }}
                      <a-icon type="copy" @click="text_copy(text.ad_info.id)" />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="delivery_setting"
                slot="delivery_setting"
                slot-scope="text"
              >
                <div v-if="text.ad_info.budget">
                  预算:{{ text.ad_info.budget }}元
                  <span v-if="text.ad_info.budget_mode == 'BUDGET_MODE_DAY'"
                    >/日</span
                  >
                  <span v-if="text.ad_info.budget_mode == 'BUDGET_MODE_TOTAL'"
                    >/总</span
                  >

                  <a-popover
                    title="设置预算"
                    placement="bottom"
                    trigger="click"
                    :getPopupContainer="
                      (triggerNode) => {
                        return triggerNode.parentNode || document.body;
                      }
                    "
                  >
                    <template slot="content">
                      <p>
                        <a-input
                          placeholder="预算需要在300~9999999.99之间"
                          v-model="new_budget"
                        />
                      </p>
                      <p>
                        <a-button
                          type="primary"
                          style="width: 100%; margin-top: 10px"
                          @click="editOne(text, new_budget, 2)"
                          :loading="btnloadiong"
                          >确定</a-button
                        >
                      </p>
                    </template>
                    <a-icon
                      type="edit"
                      @click="new_budget = text.ad_info.budget"
                    />
                  </a-popover>
                </div>
                <div v-if="text.ad_info.cpa_bid">
                  出价:{{ text.ad_info.cpa_bid }}元

                  <!-- <a-popover title="设置出价" placement="bottom" trigger="click"
                    :getPopupContainer="triggerNode => { return triggerNode.parentNode || document.body; }">
                    <template slot="content">
                      <p><a-input placeholder="设置出价" v-model="new_bid" /></p>
                      <p><a-button type="primary" style="width: 100%;" @click="editOne(text, new_bid, 1)">确定</a-button>
                      </p>
                    </template>
                    <a-icon type="edit" @click="new_bid = text.ad_info.cpa_bid" />
                  </a-popover> -->
                </div>
                <div v-if="text.ad_info.roi2_goal">
                  ROI目标:{{ text.ad_info.roi2_goal }}

                  <a-popover
                    title="设置ROI目标"
                    placement="bottom"
                    trigger="click"
                    :getPopupContainer="
                      (triggerNode) => {
                        return triggerNode.parentNode || document.body;
                      }
                    "
                  >
                    <template slot="content">
                      <p><a-input placeholder="ROI目标" v-model="new_roi" /></p>
                      <p>
                        <a-button
                          type="primary"
                          style="width: 100%; margin-top: 10px"
                          @click="editOne(text, new_roi, 3)"
                          :loading="btnloadiong"
                          >确定</a-button
                        >
                      </p>
                    </template>
                    <a-icon
                      type="edit"
                      @click="new_roi = text.ad_info.roi2_goal"
                    />
                  </a-popover>
                </div>

                <div>
                  <a-progress
                    :percent="
                      parseInt(
                        (text.stats_info.stat_cost / text.ad_info.budget) * 100
                      )
                    "
                    size="small"
                    status="active"
                    v-if="
                      parseInt(
                        (text.stats_info.stat_cost / text.ad_info.budget) * 100
                      ) < 70
                    "
                  />
                  <a-progress
                    strokeColor="#f5222d"
                    :percent="
                      parseInt(
                        (text.stats_info.stat_cost / text.ad_info.budget) * 100
                      )
                    "
                    size="small"
                    status="active"
                    v-else-if="
                      parseInt(
                        (text.stats_info.stat_cost / text.ad_info.budget) * 100
                      ) < 100 &&
                      parseInt(
                        (text.stats_info.stat_cost / text.ad_info.budget) * 100
                      ) >= 70
                    "
                  />
                  <a-progress
                    :percent="
                      parseInt(
                        (text.stats_info.stat_cost / text.ad_info.budget) * 100
                      )
                    "
                    size="small"
                    v-else
                  />
                </div>
              </div>

              <div class="aweme" slot="aweme" slot-scope="text">
                <div class="aweme-left">
                  <img
                    class="videoimg"
                    :src="text.room_info[0].anchor_avatar"
                    v-if="text.room_info[0].anchor_avatar"
                  />
                </div>
                <div class="aweme-right">
                  <a-tooltip
                    placement="top"
                    :title="text.room_info[0].anchor_name"
                    style="height: auto"
                  >
                    <div class="aweme-title" @click="getDetail(text)">
                      {{ text.room_info[0].anchor_name }}
                    </div>
                  </a-tooltip>
                  <!-- <div class="small">
                  </div> -->
                  <div class="aweme-id small">
                    ID：{{ text.room_info[0].anchor_id }}
                    <a-icon
                      type="copy"
                      @click="text_copy(text.room_info[0].anchor_id)"
                    />
                  </div>
                  <div class="small">
                    {{
                      text.ad_info.smart_bid_type == 'SMART_BID_CUSTOM'
                        ? '控成本投放'
                        : '放量投放'
                    }}
                  </div>
                </div>
              </div>

              <template slot="zt" slot-scope="text">
                <div v-if="text.ad_info.status == 'DELIVERY_OK'">
                  <a-tag color="green"> 投放中 </a-tag>
                </div>
                <div v-else>
                  <a-tag color="red">
                    {{ getStatusName(text.ad_info.status) }}
                  </a-tag>
                </div>
              </template>

              <div
                class="green-roi"
                slot="total_prepay_and_pay_order_roi2"
                slot-scope="text"
              >
                <b
                  v-if="text.stats_info.total_prepay_and_pay_order_roi2 > 0"
                  style="color: green"
                  >{{ text.stats_info.total_prepay_and_pay_order_roi2 }}</b
                >
                <b v-else style="color: red">0</b>
              </div>

              <div slot="stat_cost" slot-scope="text">
                {{ text.stats_info.stat_cost }}
              </div>

              <div slot="total_pay_order_gmv_for_roi2" slot-scope="text">
                {{ text.stats_info.total_pay_order_gmv_for_roi2 }}
              </div>

              <div slot="total_pay_order_count_for_roi2" slot-scope="text">
                {{ text.stats_info.total_pay_order_count_for_roi2 }}
              </div>

              <div slot="total_cost_per_pay_order_for_roi2" slot-scope="text">
                {{ text.stats_info.total_cost_per_pay_order_for_roi2 }}
              </div>

              <div
                slot="total_pay_order_coupon_amount_for_roi2"
                slot-scope="text"
              >
                {{ text.stats_info.total_pay_order_coupon_amount_for_roi2 }}
              </div>

              <div
                slot="total_unfinished_estimate_order_gmv_for_roi2"
                slot-scope="text"
              >
                {{
                  text.stats_info.total_unfinished_estimate_order_gmv_for_roi2
                }}
              </div>

              <div
                style="cursor: pointer"
                slot="action"
                slot-scope="text, record"
              >
                <div class="rowOperate">
                  <span
                    slot="action"
                    class="actionItem"
                    @click="getDetail(record)"
                    >详情</span
                  >
                </div>
              </div>
            </a-table>
          </div>
        </a-spin>
      </div>
    </div>

    <Detail :advertiser_id="advertiser_id" ref="detail"></Detail>

    <!-- 调控监控弹窗 -->
    <a-modal
      :visible="controlMonitorVisible"
      title="调控监控"
      width="920px"
      class="warmModal"
      centered
      @ok="saveControlMonitor"
      @cancel="handleCancelControlMonitor"
      :confirmLoading="confirmLoading"
    >
      <div style="max-height: 800px; overflow: auto">
        <!-- 追投关停 -->
        <div class="confBlock">
          <span class="cofBlockName"
            >追投关停
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.ztgt_open == 1"
              @change="warnCondition.ztgt_open = !warnCondition.ztgt_open"
            />
            <b style="margin-left: 10px; color: red">New</b>
          </span>
          <div class="confContent" v-if="warnCondition.ztgt_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition">
                  【调控支付ROI】小于
                  <a-input
                    v-model="warnCondition.ztgt_json.roi"
                    class="conditionInput"
                    placeholder="请输入支付ROI"
                  />
                  (且)【调控消耗】大于
                  <a-input-number
                    placeholder="消耗"
                    v-model="warnCondition.ztgt_json.stat_cost"
                    :min="0.01"
                    :max="10000"
                  />
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">
                当触发以上条件时
                <a-select
                  v-model="warnCondition.ztgt_json.action"
                  style="width: 200px"
                  @change="handleZtgtChange"
                >
                  <a-select-option value="wx">微信通知</a-select-option>
                  <a-select-option value="stop">自动终止调控</a-select-option>
                  <a-select-option value="wxstop"
                    >微信通知且自动终止调控</a-select-option
                  >
                </a-select>
              </div>
            </div>
          </div>
        </div>

        <!-- 高产复投 -->
        <div class="confBlock">
          <span class="cofBlockName"
            >追加调控
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.gcft_open == 1"
              @change="warnCondition.gcft_open = !warnCondition.gcft_open"
            />
            <b style="margin-left: 10px; color: red">New</b>
          </span>
          <div
            class="confContent gcft-config"
            v-if="warnCondition.gcft_open == 1"
          >

          <div class="confLine fxStart">
              <span class="confLable">执行配置</span>
              <div class="confLineC">
                <a-radio-group
                  v-model="warnCondition.gcft_json.tk_config_time"
                  button-style="solid"
                  @change="onGcftTkConfigTimeChange"
                >
                  <a-radio-button value="1">
                    多时段同配置
                  </a-radio-button>
                  <a-radio-button value="2">
                    多时段不同配置
                  </a-radio-button>
                </a-radio-group>
            </div>
            </div>


<div v-if="warnCondition.gcft_json.tk_config_time == '1'">
            <div class="confLine fxStart">
              <span class="confLable">执行时段</span>
              <div class="confLineC">
                <div class="actionCondition" style="flex-wrap: wrap;">
                  <div 
                    v-for="(time, index) in warnCondition.gcft_json.times" 
                    :key="index"
                    style="display: flex; align-items: center; margin-bottom: 10px; width: 100%;"
                  >
                    <span style="margin-right: 5px;">时段{{ index + 1 }}：</span>
                    <a-time-picker
                      :allowClear="false"
                      @change="
                        (t, timeString) =>
                          onMultiTimeChange(timeString, index, 'gcft_json')
                      "
                      style="width: 100px; margin-right: 10px;"
                      :value="moment(time, 'HH:mm')"
                      :default-value="moment(time, 'HH:mm')"
                      format="HH:mm"
                    />
                    <a-icon 
                      type="delete" 
                      @click="removeMultiTime(index, 'gcft_json')"
                      style="color: #ff4d4f; cursor: pointer; font-size: 16px;"
                      v-if="warnCondition.gcft_json.times.length > 1"
                    />
                  </div>
                  <a-button 
                    type="dashed" 
                    @click="addMultiTime('gcft_json')"
                    style="width: 100%; margin-top: 10px;"
                    :disabled="warnCondition.gcft_json.times.length >= 10"
                  >
                    <a-icon type="plus" />
                    添加时段
                  </a-button>
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作：</span>
              <div class="confLineC" style="color: green; font-weight: bold">
                微信通知且自动复投一笔
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">追投配置：</span>
              <div class="confLineC">
                <div>
                  <div class="title-box level-2 normal">
                    调控时长
                    (可设范围0.5-24小时。注意：有起量需求时，建议提前10分钟创建任务)
                  </div>
                  <div class="external-action-wrapper" style="text-align: left">
                    <a-input
                      v-model="warnCondition.gcft_json.duration"
                      placeholder="调控时长"
                      style="width: 130px"
                    >
                      <div
                        slot="addonBefore"
                        style="cursor: pointer"
                        @click="onGcftDurationDrop"
                      >
                        <a-icon type="minus" />
                      </div>
                      <div
                        slot="addonAfter"
                        style="cursor: pointer"
                        @click="onGcftDurationRise"
                      >
                        <a-icon type="plus" />
                      </div>
                    </a-input>

                    <span
                      style="
                        margin-left: 10px;
                        font-size: 16px;
                        line-height: 30px;
                      "
                    >
                      小时</span
                    >
                  </div>

                  <div class="title-box level-2 normal">
                    调控预算
                    (调控预算为额外追加的独立预算，调控预算越高ROI下降风险越大，且不支持成本保障，请合理设置)
                  </div>
                  <div class="delivery-schedule-wrapper">
                    <div class="container interval normal">
                      <a-radio-group
                        :value="warnCondition.gcft_json.budget"
                        @change="handleGcftBudgetChange"
                      >
                        <a-radio-button value="100"> 100元 </a-radio-button>
                        <a-radio-button value="200"> 200元 </a-radio-button>
                        <a-radio-button value="500"> 500元 </a-radio-button>
                        <a-radio-button value="1000"> 1000元 </a-radio-button>
                        <a-radio-button value="2000"> 2000元 </a-radio-button>
                        <a-radio-button value="-1"> 自定义 </a-radio-button>
                      </a-radio-group>
                      <a-input-number
                        :min="10"
                        :max="50000"
                        placeholder="最低10元"
                        v-model="warnCondition.gcft_json.diyamount"
                        v-if="warnCondition.gcft_json.budget == '-1'"
                        class="cpa_bid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

</div>
<div v-if="warnCondition.gcft_json.tk_config_time == '2'">
            <div class="confLine fxStart">
              <span class="confLable">执行时段</span>
              <div class="confLineC">
                <div class="actionCondition" style="flex-wrap: wrap;">
                  <div
                    v-for="(slot, index) in (warnCondition.gcft_json.slot_configs || [])"
                    :key="'slot-' + index"
                    style="
                      margin-bottom: 16px;
                      width: 100%;
                      padding: 12px;
                      border: 1px solid #e8e8e8;
                      border-radius: 4px;
                      background: #fafafa;
                    "
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        margin-bottom: 10px;
                      "
                    >
                      <span style="margin-right: 8px; font-weight: 600"
                        >时段{{ index + 1 }}</span
                      >
                      <a-time-picker
                        :allowClear="false"
                        style="width: 100px; margin-right: 10px"
                        :value="moment(slot.time, 'HH:mm')"
                        format="HH:mm"
                        @change="
                          (t, timeString) =>
                            onGcftSlotTimeChange(timeString, index)
                        "
                      />
                      <a-icon
                        type="delete"
                        style="color: #ff4d4f; cursor: pointer; font-size: 16px"
                        v-if="warnCondition.gcft_json.slot_configs.length > 1"
                        @click="removeGcftSlotConfig(index)"
                      />
                    </div>
                    <div class="title-box level-2 normal" style="margin-bottom: 6px">
                      追加时长（调控时长，0.5～24 小时）
                    </div>
                    <div class="external-action-wrapper" style="text-align: left">
                      <a-input
                        :value="slot.duration"
                        placeholder="追加时长"
                        style="width: 130px"
                        @change="
                          (e) =>
                            onGcftSlotDurationInput(index, e.target.value)
                        "
                      >
                        <div
                          slot="addonBefore"
                          style="cursor: pointer"
                          @click="onGcftSlotDurationDrop(index)"
                        >
                          <a-icon type="minus" />
                        </div>
                        <div
                          slot="addonAfter"
                          style="cursor: pointer"
                          @click="onGcftSlotDurationRise(index)"
                        >
                          <a-icon type="plus" />
                        </div>
                      </a-input>
                      <span
                        style="
                          margin-left: 10px;
                          font-size: 16px;
                          line-height: 30px;
                        "
                        >小时</span
                      >
                    </div>
                    <div class="title-box level-2 normal" style="margin: 10px 0 6px">
                      调控预算（追加的独立预算）
                    </div>
                    <div class="delivery-schedule-wrapper">
                      <div class="container interval normal">
                        <a-radio-group
                          :value="slot.budget"
                          @change="
                            (e) => handleGcftSlotBudgetChange(e, index)
                          "
                        >
                          <a-radio-button value="100"> 100元 </a-radio-button>
                          <a-radio-button value="200"> 200元 </a-radio-button>
                          <a-radio-button value="500"> 500元 </a-radio-button>
                          <a-radio-button value="1000"> 1000元 </a-radio-button>
                          <a-radio-button value="2000"> 2000元 </a-radio-button>
                          <a-radio-button value="-1"> 自定义 </a-radio-button>
                        </a-radio-group>
                        <a-input-number
                          :min="10"
                          :max="50000"
                          placeholder="最低10元"
                          :value="gcftSlotDiyNumber(slot.diyamount)"
                          @change="(v) => onGcftSlotDiyChange(index, v)"
                          v-if="String(slot.budget) === '-1'"
                          class="cpa_bid"
                          style="margin-top: 8px"
                        />
                      </div>
                    </div>
                  </div>
                  <a-button
                    type="dashed"
                    style="width: 100%"
                    @click="addGcftSlotConfig"
                    :disabled="
                      (warnCondition.gcft_json.slot_configs || []).length >= 10
                    "
                  >
                    <a-icon type="plus" />
                    添加时段
                  </a-button>
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作：</span>
              <div class="confLineC" style="color: green; font-weight: bold">
                微信通知且自动复投一笔
              </div>
            </div>
          </div>


          </div>
        </div>

        <!-- 调控素材配置 -->
        <div class="confBlock">
          <span class="cofBlockName"
            >调控素材配置
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.diy_open == 1"
              @change="
                warnCondition.diy_open = warnCondition.diy_open == 1 ? 0 : 1
              "
            />
          </span>
          <div class="confContent diy-material-config" v-if="warnCondition.diy_open == 1">
           
            <div
              v-for="(rule, index) in warnCondition.diy_rules"
              :key="'diy-rule-' + index"
              class="diy-rule-card"
            >
              <div class="diy-rule-card__head">
                <span class="diy-rule-card__title">规则 {{ index + 1 }}</span>
                <a-icon
                  v-if="warnCondition.diy_rules.length > 1"
                  type="delete"
                  class="diy-rule-card__delete"
                  @click="removeDiyRule(index)"
                />
              </div>
              <div class="confLine fxStart">
                <span class="confLable">执行条件</span>
                <div class="confLineC">
                  <div class="actionCondition" style="flex-wrap: wrap">
                    消耗
                    <a-select
                      :value="rule.x_relation"
                      style="width: 88px; margin: 0 8px"
                      @change="(v) => setDiyRuleField(index, 'x_relation', v)"
                    >
                      <a-select-option value=">">大于</a-select-option>
                      <a-select-option value="<">小于</a-select-option>
                      <a-select-option value=">=">大于等于</a-select-option>
                      <a-select-option value="<=">小于等于</a-select-option>
                    </a-select>
                    <a-input-number
                      :value="diyRuleNumber(rule.x_value)"
                      :min="0"
                      placeholder="消耗"
                      style="width: 120px; margin-right: 8px"
                      @change="(v) => setDiyRuleField(index, 'x_value', v)"
                    />
                    且 支付ROI
                    <a-select
                      :value="rule.y_relation"
                      style="width: 88px; margin: 0 8px"
                      @change="(v) => setDiyRuleField(index, 'y_relation', v)"
                    >
                      <a-select-option value=">">大于</a-select-option>
                      <a-select-option value="<">小于</a-select-option>
                      <a-select-option value=">=">大于等于</a-select-option>
                      <a-select-option value="<=">小于等于</a-select-option>
                    </a-select>
                    <a-input-number
                      :value="diyRuleNumber(rule.y_value)"
                      :min="0"
                      :step="0.01"
                      placeholder="ROI"
                      style="width: 120px"
                      @change="(v) => setDiyRuleField(index, 'y_value', v)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <a-button
              type="dashed"
              style="width: 100%"
              @click="addDiyRule"
              :disabled="warnCondition.diy_rules.length >= 10"
            >
              <a-icon type="plus" />
              添加规则
            </a-button>
            <div class="confLine" style="margin-top: 10px;">
              <span class="confLable">执行操作</span>
              <div class="confLineC">
                <a-select v-model="warnCondition.diy_action" style="width: 240px">
                  <a-select-option value="delete">自动删除素材</a-select-option>
                  <a-select-option value="wxdelete"
                    >微信通知且自动删除素材</a-select-option
                  >
                  <a-select-option value="wx">微信通知</a-select-option>
                </a-select>
              </div>
            </div>
            <div style="margin-top: 8px; color: #999; font-size: 12px">
              示例：消耗大于70且支付ROI小于0.5；可追加多组条件，执行操作统一生效。
            </div>
          </div>
        </div>
      </div>

      <div style="font-size: 12px; color: #999; margin-top: 20px">
        免责声明：尊敬的用户，因自动化预警功能的实现需要抖音官方Markting API
        接口返回数据，如因官方接口返回数据或其他数据异常导致执行操作错误，抖川助手不承担任何法律责任。
      </div>
    </a-modal>
  </div>
</template>
<script>
import { qcApi, requestHttp, isNumber } from '@utils/index';
import { Modal } from 'ant-design-vue';
import Detail from './components/detail.vue';

import moment from 'moment';
import { get } from 'store';
const columns = [
  {
    title: '计划信息',
    key: 'ad',
    width: 250,
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'ad' },
    fixed: 'left',
  },
  {
    title: '投放信息',
    key: 'aweme',
    width: 300,
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'aweme' },
    // fixed: 'left',
  },
  {
    title: '计划状态',
    key: 'zt',
    width: 200,
    align: 'center',
    scopedSlots: { customRender: 'zt' },
  },
  {
    title: '预算/出价',
    key: 'delivery_setting',
    align: 'left',
    width: 150,
    scopedSlots: { customRender: 'delivery_setting' },
  },
  {
    title: '消耗（元）',
    key: 'stat_cost',
    align: 'center',
    sorter: true,
    scopedSlots: { customRender: 'stat_cost' },
  },
  {
    title: '整体支付ROI',
    key: 'total_prepay_and_pay_order_roi2',
    align: 'center',
    sorter: true,
    scopedSlots: { customRender: 'total_prepay_and_pay_order_roi2' },
  },
  {
    title: '整体成交金额',
    key: 'total_pay_order_gmv_for_roi2',
    align: 'center',
    sorter: true,
    scopedSlots: { customRender: 'total_pay_order_gmv_for_roi2' },
  },
  {
    title: '整体成交订单数',
    key: 'total_pay_order_count_for_roi2',
    align: 'center',
    sorter: true,
    scopedSlots: { customRender: 'total_pay_order_count_for_roi2' },
  },
  {
    title: '整体成交订单成本',
    key: 'total_cost_per_pay_order_for_roi2',
    align: 'center',
    sorter: true,
    scopedSlots: { customRender: 'total_cost_per_pay_order_for_roi2' },
  },
  {
    title: '整体成交智能优惠券金额',
    key: 'total_pay_order_coupon_amount_for_roi2',
    align: 'center',
    sorter: true,
    scopedSlots: { customRender: 'total_pay_order_coupon_amount_for_roi2' },
  },
  {
    title: '整体未完结预售订单预估金额',
    key: 'total_unfinished_estimate_order_gmv_for_roi2',
    align: 'center',
    sorter: true,
    scopedSlots: {
      customRender: 'total_unfinished_estimate_order_gmv_for_roi2',
    },
  },
  {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 120,
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },
];
const data = [];
const key = 'updatable';
export default {
  name: 'ShowTemplate',
  props: {
    advertiser_id: {
      type: String,
      default: '',
    },
    marketing_goal: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      spinning: false,
      columns,
      data,
      status: '', // 分页参数
      report: {},
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        hideOnSinglePage: false,
        showQuickJumper: true,
        showSizeChanger: true,
      },
      page: 1,
      pagesize: 10,
      selectedRow: [],
      selectedRowKeys: [],
      statusData: [
        { name: '全部计划状态', value: '' },
        { name: '新建审核中', value: 'AUDIT' },
        { name: '已删除', value: 'DELETE' },
        { name: '投放中', value: 'DELIVERY_OK' },
        { name: '已暂停', value: 'DISABLE' },
        { name: '草稿', value: 'DRAFT' },
        { name: '数据错误', value: 'ERROR' },
        { name: '落地页暂不可用', value: 'EXTERNAL_URL_DISABLE' },
        { name: '已终止', value: 'FROZEN' },
        { name: '关联直播间未开播', value: 'LIVE_ROOM_OFF' },
        { name: '不在投放时段', value: 'NO_SCHEDULE' },
        { name: '审核不通过', value: 'OFFLINE_AUDIT' },
        { name: '账户余额不足', value: 'OFFLINE_BALANCE' },
        { name: '广告超出预算', value: 'OFFLINE_BUDGET' },
        { name: '预上线', value: 'PRE_ONLINE' },
        { name: 'QUOTA配额不足暂停计划', value: 'QUOTA_DISABLE' },
        { name: '修改审核中', value: 'REAUDIT' },
        { name: '全域推广暂停', value: 'ROI2_DISABLE' },
        { name: '系统暂停', value: 'SYSTEM_DISABLE' },
        { name: '已完成', value: 'TIME_DONE' },
        { name: '未到达投放时间', value: 'TIME_NO_REACH' },
        { name: '账户超出预算', value: 'ADVERTISER_OFFLINE_BUDGET' },
        { name: '账户接近预算', value: 'ADVERTISER_PRE_OFFLINE_BUDGET' },
        { name: '异常，请联系审核人员', value: 'AUDIT_STATUS_ERROR' },
        { name: '关联抖音号不可投', value: 'AWEME_ACCOUNT_DISABLED' },
        { name: '已被广告组暂停', value: 'CAMPAIGN_DISABLE' },
        { name: '广告组超出预算', value: 'CAMPAIGN_OFFLINE_BUDGET' },
        { name: '广告组接近预算', value: 'CAMPAIGN_PRE_OFFLINE_BUDGET' },
      ],
      smart_bid_type: 'SMART_BID_CUSTOM',
      ad: {},
      dataMap: {},
      deadline: Date.now() + 1000 * 31,
      deadtitle: '定时刷新中：倒计时',
      sortby: 'ad_id',
      sort: 'descend',
      order_id: '',
      timeType: 'ALL',
      range_date: [
        moment().format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],
      timeday: '0',
      toploading: false,
      topkey: 1,
      switchloading: false,
      timer_status: true,
      releshBtn: false,
      xData: [],
      y1: [],
      y2: [],
      y3: [],
      y4: [],
      y5: [],
      y6: [],
      new_budget: '',
      new_bid: '',
      new_roi: '',
      tableKey: '1',
      totalItem: {
        stat_cost: '-',
        pay_order_amount: '-',
        prepay_and_pay_order_roi: '-',
        pay_order_count: '-',
      },
      logDrawer: false,
      log_data: [],
      btnloadiong: false,
      controlMonitorVisible: false,
      confirmLoading: false,
      currentAd: null,
      warnCondition: {
        day:1,
        ztgt_open: 0,
        ztgt_json: {
          action: 'wxstop',
          stat_cost: '',
          roi: '',
        },
        gcft_open: 0,
        gcft_json: {
          tk_config_time: '1',
          action: 'wx',
          budget: '100',
          duration: '12',
          diyamount: '',
          roi: '',
          stat_cost: '',
          times: ['00:00'],
          slot_configs: [],
        },
        diy_open: 0,
        diy_action: 'delete',
        diy_rules: [
          {
            x: 'stat_cost_for_roi2',
            x_value: '',
            x_relation: '>',
            y: 'total_prepay_and_pay_order_roi2',
            y_value: '',
            y_relation: '<',
          },
        ],
        diy_json: null,
      },
    };
  },

  components: {
    Detail,
  },

  watch: {
    advertiser_id(a, b) {
      this.page = 1;
      this.pagination.current = 1;
      this.order_id = '';
      this.getData();
      this.getReport();
      this.selectedRowKeys = [];
    },
  },

  methods: {
    moment,
    async editOne(e, edit_value, edittype) {
      this.btnloadiong = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.EDIT_QY_AD}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          ad_id: e.ad_info.id,
          edittype: edittype,
          edit_value: edit_value,
        },
      });
      this.btnloadiong = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg);
      this.data = [];
      this.getData();
    },
    createBtn() {
      console.log(this.smart_bid_type);
      this.$message.success('暂未更新');
    },
    getStatusName(status) {
      const statusItem = this.statusData.find((item) => item.value === status);
      return statusItem ? statusItem.name : status;
    },
    getChecked(type) {
      let status = false;
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].key == type) {
          status = true;
        }
      }
      return status;
    },
    clearSelect() {
      this.selectedRowKeys = [];
      this.getData();
    },
    changeDetailTopTab(e) {
      this.detailTab = e;
    },
    async releshAll() {
      this.releshBtn = true;
      this.getData();
      this.releshBtn = false;
    },
    changeTimerStatus() {
      this.timer_status = !this.timer_status;
      if (this.timer_status) {
        this.deadline = Date.now() + 1000 * 31;
      }
    },
    addwhite(e, type) {
      const that = this;
      Modal.confirm({
        title: '加白提醒',
        content:
          type == 'add'
            ? '是否确定加白该计划？加白后该计划后该计划将不会被监控。'
            : '是否确定取消加白该计划？取消加白后该计划后该计划将会重新被监控。',
        onOk: () => {
          that.addwhiteAction(e, type);
        },
      });
    },
    async addwhiteAction(e, type) {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.QC_ADD_AD_WHITE}`,
        method: 'POST',
        params: {
          advertiser_id: e.advertiser_id,
          ad_id: e.ad_id,
          marketing_goal: e.marketing_goal,
          order_create_day: e.order_create_day,
          type: type,
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.data = [];
      this.$message.success(msg);
      this.getData();
    },
    async onSwitchChange(e) {
      this.switchloading = true;
      let opt_status = e.ad_info.opt_status == 'ENABLE' ? 'DISABLE' : 'ENABLE';
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.STOP_QY_AD}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          ad_id: e.ad_info.id,
          opt_status: opt_status,
        },
      });
      this.switchloading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg);
      e.ad_info.opt_status = opt_status;
    },
    setTimeDay(timeday) {
      this.timeday = timeday;
      let todayDate = moment().format('YYYY-MM-DD');
      if (timeday == 0) {
        this.range_date = [todayDate, todayDate];
      } else if (timeday == -1) {
        this.range_date = [
          moment().subtract(1, 'days').format('YYYY-MM-DD'),
          moment().subtract(1, 'days').format('YYYY-MM-DD'),
        ];
      } else if (timeday == -3) {
        this.range_date = [
          moment().subtract(3, 'days').format('YYYY-MM-DD'),
          todayDate,
        ];
      } else if (timeday == -7) {
        this.range_date = [
          moment().subtract(7, 'days').format('YYYY-MM-DD'),
          todayDate,
        ];
      } else if (timeday == 1) {
        this.range_date = [
          moment().startOf('month').format('YYYY-MM-DD'),
          todayDate,
        ];
      } else if (timeday == 2) {
        this.range_date = [
          moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
          moment()
            .subtract(1, 'months')
            .endOf('month')
            .format('YYYY-MM-DD')
            .split('T')[0],
        ];
      }
      this.getReport();
    },
    onTimeChange(e, date) {
      this.range_date = date;
      this.timeday = '';
      this.getReport();
    },
    text_copy(context) {
      navigator.clipboard
        .writeText(context)
        .then(() => {
          this.$message.success('复制成功');
        })
        .catch((err) => {
          this.$message.error('复制失败');
        });
    },
    onSearchKey(e) {
      this.order_id = e;
      this.page = 1;
      this.data = [];
      this.getData();
    },
    onFinish() {
      if (!this.timer_status) {
        return;
      }
      this.$message.loading({ content: '刷新中...', key });
      this.deadtitle = '定时刷新中：正在刷新...';
      this.getReport();
      setTimeout(() => {
        this.$message.success({ content: '刷新成功!', key, duration: 2 });
        this.deadtitle = '定时刷新中：倒计时';
        this.deadline = Date.now() + 1000 * 31;
      }, 1000);
    },
    getDetail(e) {
      this.ad = e;
      this.$refs.detail.getAdDetail(e);
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRow = selectedRows;
      this.selectedRowKeys = selectedRowKeys;
    },
    // handleTableChange(e, filters, sorter) {
    //   if (sorter.order) {
    //     this.sort = sorter.order
    //     this.sortby = sorter.field
    //   } else {
    //     this.sort = 'descend'
    //     this.sortby = 'create_time'
    //   }
    //   this.pagination = e;
    //   this.page = e.current;
    //   this.pagesize = e.pageSize;
    //   this.getData();
    // },

    handleTableChange(e, filters, sorter) {
      console.log('点击了', sorter);

      // 检查排序条件是否发生变化
      const sortChanged =
        sorter.order &&
        (this.sort !== sorter.order || this.sortby !== sorter.columnKey);

      // 设置排序参数
      if (sorter.order) {
        this.sort = sorter.order;
        this.sortby = sorter.columnKey;
      } else {
        this.sort = 'descend';
        this.sortby = 'create_time';
      }

      // 只有在排序条件改变时才重置页码
      if (sortChanged) {
        this.page = 1;
        this.pagination = {
          ...e,
          current: 1,
        };
      } else {
        // 正常分页逻辑
        this.page = e.current;
        this.pagination = e;
      }

      this.pagesize = e.pageSize;
      this.getData();
    },
    async handleChange(e) {
      this.status = e;
      this.getData();
    },
    handletargetChange(e) {
      this.smart_bid_type = e.target.value;
      this.getData();
    },
    async getData() {
      this.spinning = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QY_AD_LIST}`,
        method: 'POST',
        params: {
          start_date: this.range_date[0] ? this.range_date[0] : '',
          end_date: this.range_date[1] ? this.range_date[1] : '',
          advertiser_id: this.advertiser_id,
          status: this.status,
          marketing_goal: this.marketing_goal,
          search_keyword: this.order_id,
          sortby: this.sortby,
          sort: this.sort,
          page: this.page,
          pagesize: this.pagesize,
          smart_bid_type: this.smart_bid_type,
          adlab_scene:'OVERALL_PROJECT'
        },
      });
      this.spinning = false;
      if (code == 0) {
        return;
      }
      if (!data) return;
      this.data = data.ad_list;
      this.pagination.total = data.page_info.total_num;
    },
    async getReport() {
      this.toploading = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QY_ADVERTISER_REPORT}`,
        method: 'POST',
        params: {
          source: 'SXT',
          advertiser_id: this.advertiser_id,
          marketing_goal: this.marketing_goal,
          start_date: this.range_date[0] ? this.range_date[0] : '',
          end_date: this.range_date[1] ? this.range_date[1] : '',
        },
      });
      this.toploading = false;
      if (code == 0) {
        return;
      }
      if (!data) return;
      this.report = data;
      this.getData();
    },
    createDefaultDiyRule() {
      return {
        x: 'stat_cost_for_roi2',
        x_value: '',
        x_relation: '>',
        y: 'total_prepay_and_pay_order_roi2',
        y_value: '',
        y_relation: '<',
      };
    },
    parseDiyActionFromData(data, rules) {
      if (data && data.diy_action) {
        return data.diy_action;
      }
      let diy = data && data.diy_json;
      if (typeof diy === 'string') {
        try {
          diy = JSON.parse(diy);
        } catch (e) {
          diy = null;
        }
      }
      if (diy && diy.action) {
        return diy.action;
      }
      if (Array.isArray(rules) && rules.length && rules[0].action) {
        return rules[0].action;
      }
      return 'delete';
    },
    mapDiyRuleCondition(rule) {
      const { action, ...condition } = rule || {};
      return {
        ...this.createDefaultDiyRule(),
        ...condition,
        x_value:
          condition.x_value !== undefined && condition.x_value !== null
            ? condition.x_value
            : '',
        y_value:
          condition.y_value !== undefined && condition.y_value !== null
            ? condition.y_value
            : '',
      };
    },
    buildDefaultWarnCondition() {
      return {
        day: 1,
        ztgt_open: 0,
        ztgt_json: {
          action: 'wxstop',
          stat_cost: '',
          roi: '',
        },
        gcft_open: 0,
        gcft_json: {
          tk_config_time: '1',
          action: 'wx',
          budget: '100',
          duration: '12',
          diyamount: '',
          roi: '',
          stat_cost: '',
          times: ['00:00'],
          slot_configs: [],
        },
        diy_open: 0,
        diy_action: 'delete',
        diy_rules: [this.createDefaultDiyRule()],
        diy_json: null,
      };
    },
    parseDiyRulesFromData(data) {
      if (!data) {
        return [this.createDefaultDiyRule()];
      }
      if (Array.isArray(data.diy_rules) && data.diy_rules.length) {
        return data.diy_rules.map((rule) => this.mapDiyRuleCondition(rule));
      }
      let diy = data.diy_json;
      if (typeof diy === 'string') {
        try {
          diy = JSON.parse(diy);
        } catch (e) {
          diy = null;
        }
      }
      if (diy && typeof diy === 'object' && !Array.isArray(diy)) {
        return [this.mapDiyRuleCondition(diy)];
      }
      return [this.createDefaultDiyRule()];
    },
    diyRuleNumber(val) {
      if (val === '' || val === null || val === undefined) {
        return undefined;
      }
      const num = Number(val);
      return Number.isFinite(num) ? num : undefined;
    },
    setDiyRuleField(index, field, value) {
      const rules = this.warnCondition.diy_rules || [];
      if (!rules[index]) return;
      const next = { ...rules[index] };
      if (field === 'x_value' || field === 'y_value') {
        next[field] =
          value === null || value === undefined || value === ''
            ? ''
            : String(value);
      } else {
        next[field] = value;
      }
      this.$set(this.warnCondition.diy_rules, index, next);
    },
    addDiyRule() {
      if (!Array.isArray(this.warnCondition.diy_rules)) {
        this.$set(this.warnCondition, 'diy_rules', [this.createDefaultDiyRule()]);
        return;
      }
      if (this.warnCondition.diy_rules.length >= 10) {
        this.$message.warning('最多添加10条规则');
        return;
      }
      this.warnCondition.diy_rules.push(this.createDefaultDiyRule());
    },
    removeDiyRule(index) {
      if (!Array.isArray(this.warnCondition.diy_rules)) return;
      if (this.warnCondition.diy_rules.length <= 1) {
        this.$message.warning('至少保留一条规则');
        return;
      }
      this.warnCondition.diy_rules.splice(index, 1);
    },
    syncDiyRulesBeforeSave() {
      if (!this.warnCondition.diy_open) {
        return;
      }
      const action = this.warnCondition.diy_action || 'delete';
      const conditions = (this.warnCondition.diy_rules || []).map((rule) =>
        this.mapDiyRuleCondition(rule)
      );
      const rules = conditions.map((rule) => ({
        ...rule,
        action,
      }));
      this.$set(this.warnCondition, 'diy_rules', rules);
      this.$set(this.warnCondition, 'diy_action', action);
      if (rules.length) {
        this.$set(this.warnCondition, 'diy_json', { ...rules[0] });
      }
    },
    // 打开调控监控弹窗
    async settk(ad) {
      this.currentAd = ad;
      this.controlMonitorVisible = true;
      this.confirmLoading = true;
      
      // 先查询配置详情
      try {
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.GET_QY_MATERIAL_MONITOR_DETAIL}`,
          method: 'POST',
          params: {
            advertiser_id: ad.advertiser_id,
            ad_id: ad.ad_info.id,
            marketing_goal: 'LIVE_PROM_GOODS',
            adlab_scene:'OVERALL_PROJECT'
          },
        });
        
        this.confirmLoading = false;
        
        if (code == 0) {
          this.$message.error(msg || '查询配置失败');
          this.$set(this, 'warnCondition', this.buildDefaultWarnCondition());
          return;
        }
        
        // 如果查询成功且有数据，使用返回的配置
        if (data) {
          try {
            // 接口返回的数据结构：配置字段直接在 data 对象中
            // 处理 day 字段（可能是字符串 "1" 或数字 1）
            const day = data.day ? (typeof data.day === 'string' ? parseInt(data.day) : data.day) : 1;
            
            // 处理 ztgt_json（可能是字符串或对象）
            let ztgt_json = {
              action: 'wxstop',
              stat_cost: '',
              roi: '',
            };
            if (data.ztgt_json) {
              if (typeof data.ztgt_json === 'string') {
                try {
                  ztgt_json = JSON.parse(data.ztgt_json);
                } catch (e) {
                  console.error('解析 ztgt_json 失败:', e);
                }
              } else {
                ztgt_json = {
                  action: data.ztgt_json.action || 'wxstop',
                  stat_cost: data.ztgt_json.stat_cost !== undefined ? String(data.ztgt_json.stat_cost) : '',
                  roi: data.ztgt_json.roi !== undefined ? String(data.ztgt_json.roi) : '',
                };
              }
            }
            
            // 处理 gcft_json（可能是字符串或对象）
            let gcft_json = {
              action: 'wx',
              budget: '100',
              duration: '12',
              diyamount: '',
              roi: '',
              stat_cost: '',
              times: ['00:00'],
              tk_config_time:'1',
              slot_configs: [],
            };
            if (data.gcft_json) {
              if (typeof data.gcft_json === 'string') {
                try {
                  gcft_json = JSON.parse(data.gcft_json);
                } catch (e) {
                  console.error('解析 gcft_json 失败:', e);
                }
              } else {
                gcft_json = {
                  tk_config_time: data.gcft_json.tk_config_time||'1',
                  action: data.gcft_json.action || 'wx',
                  budget: data.gcft_json.budget !== undefined ? String(data.gcft_json.budget) : '100',
                  duration: data.gcft_json.duration !== undefined ? String(data.gcft_json.duration) : '12',
                  diyamount: data.gcft_json.diyamount !== undefined ? String(data.gcft_json.diyamount) : '',
                  roi: data.gcft_json.roi !== undefined ? String(data.gcft_json.roi) : '',
                  stat_cost: data.gcft_json.stat_cost !== undefined ? String(data.gcft_json.stat_cost) : '',
                  times: Array.isArray(data.gcft_json.times) && data.gcft_json.times.length > 0
                    ? data.gcft_json.times 
                    : ['00:00'],
                  slot_configs: Array.isArray(data.gcft_json.slot_configs)
                    ? data.gcft_json.slot_configs
                    : [],
                };
              }
            }
            this.normalizeGcftSlotConfigs(gcft_json);

            const diy_open =
              data.diy_open !== undefined
                ? data.diy_open === 1 || data.diy_open === '1'
                  ? 1
                  : 0
                : 0;
            const diy_rules = this.parseDiyRulesFromData(data);
            const diy_action = this.parseDiyActionFromData(data, data.diy_rules);

            // 使用 $set 确保响应式更新
            this.$set(this, 'warnCondition', {
              day: day,
              ztgt_open: data.ztgt_open !== undefined ? (data.ztgt_open === 1 || data.ztgt_open === '1' ? 1 : 0) : 0,
              ztgt_json: ztgt_json,
              gcft_open: data.gcft_open !== undefined ? (data.gcft_open === 1 || data.gcft_open === '1' ? 1 : 0) : 0,
              gcft_json: gcft_json,
              diy_open,
              diy_action,
              diy_rules,
              diy_json: diy_rules.length
                ? { ...diy_rules[0], action: diy_action }
                : null,
            });
            
            // 使用 $nextTick 确保 DOM 更新后再进行后续操作
            this.$nextTick(() => {
              console.log('配置数据已回填到弹窗:', this.warnCondition);
            });
          } catch (parseError) {
            console.error('解析配置数据失败:', parseError);
            this.$set(this, 'warnCondition', this.buildDefaultWarnCondition());
          }
        } else {
          this.$set(this, 'warnCondition', this.buildDefaultWarnCondition());
        }
      } catch (error) {
        console.error('查询配置详情失败:', error);
        this.confirmLoading = false;
        this.$message.error('查询配置详情失败');
        this.$set(this, 'warnCondition', this.buildDefaultWarnCondition());
      }
    },
    // 关闭调控监控弹窗
    handleCancelControlMonitor() {
      this.controlMonitorVisible = false;
      this.currentAd = null;
    },
    // 保存调控监控配置
    async saveControlMonitor() {
      if (this.warnCondition.ztgt_open) {
        if (!this.warnCondition.ztgt_json.roi) {
          this.$message.error('您已开启【追投关停监控】配置，请设置参数roi');
          return;
        }
        if (!this.warnCondition.ztgt_json.stat_cost) {
          this.$message.error('您已开启【追投关停监控】配置，请设置参数消耗');
          return;
        }
      }
      if (this.warnCondition.gcft_open == 1) {
        const g = this.warnCondition.gcft_json;
        if (String(g.tk_config_time) === '2') {
          const slots = g.slot_configs || [];
          if (!slots.length) {
            this.$message.error(
              '【追加调控】多时段不同配置下请至少保留一个时段'
            );
            return;
          }
          for (let i = 0; i < slots.length; i++) {
            const s = slots[i];
            const d = parseFloat(s.duration);
            if (isNaN(d) || d < 0.5 || d > 24) {
              this.$message.error(
                `【追加调控】时段${i + 1} 追加时长需在 0.5～24 小时之间`
              );
              return;
            }
            if (String(s.budget) === '-1') {
              const diy = parseFloat(s.diyamount);
              if (isNaN(diy) || diy < 10) {
                this.$message.error(
                  `【追加调控】时段${i + 1} 自定义调控预算不能低于10元`
                );
                return;
              }
            }
          }
        }
      }
      if (this.warnCondition.diy_open == 1) {
        const rules = this.warnCondition.diy_rules || [];
        if (!rules.length) {
          this.$message.error('【调控素材配置】请至少添加一条规则');
          return;
        }
        for (let i = 0; i < rules.length; i++) {
          const r = rules[i];
          if (
            r.x_value === '' ||
            r.x_value === null ||
            r.x_value === undefined
          ) {
            this.$message.error(`【调控素材配置】规则${i + 1}请设置消耗条件`);
            return;
          }
          if (
            r.y_value === '' ||
            r.y_value === null ||
            r.y_value === undefined
          ) {
            this.$message.error(`【调控素材配置】规则${i + 1}请设置ROI条件`);
            return;
          }
        }
      }
      // if (this.warnCondition.gcft_open) {
      //   if (!this.warnCondition.gcft_json.roi) {
      //     this.$message.error('您已开启【高产复投】配置，请设置支付ROI参数');
      //     return;
      //   }
      //   if (!this.warnCondition.gcft_json.stat_cost) {
      //     this.$message.error('您已开启【高产复投】配置，请设置消耗参数');
      //     return;
      //   }
      // }

      Modal.confirm({
        title: '提示',
        content: '是否确认保存？',
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          this.confirmLoading = true;
          await this.saveControlMonitorAction();
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    // 执行保存操作
    async saveControlMonitorAction() {
      if (!this.currentAd) {
        this.$message.error('计划信息不存在');
        this.confirmLoading = false;
        return;
      }

      const g = this.warnCondition.gcft_json;
      if (
        this.warnCondition.gcft_open == 1 &&
        String(g.tk_config_time) === '2' &&
        Array.isArray(g.slot_configs) &&
        g.slot_configs.length
      ) {
        this.$set(
          g,
          'times',
          g.slot_configs.map((s) => s.time || '00:00')
        );
        const f0 = g.slot_configs[0];
        this.$set(
          g,
          'duration',
          String(f0.duration != null ? f0.duration : '12')
        );
        this.$set(
          g,
          'budget',
          String(f0.budget != null ? f0.budget : '100')
        );
        this.$set(
          g,
          'diyamount',
          f0.diyamount != null ? String(f0.diyamount) : ''
        );
      }

      this.syncDiyRulesBeforeSave();

      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SET_QY_MATERIAL_MONITOR}`,
        method: 'POST',
        params: {
          advertiser_id: this.currentAd.advertiser_id,
          ad_id: this.currentAd.ad_info.id, // 计划ID
          marketing_goal: 'LIVE_PROM_GOODS',
          adlab_scene:'OVERALL_PROJECT',
          warnCondition: JSON.stringify(this.warnCondition), // day 在 warnCondition 里面
        },
      });
      this.confirmLoading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg);
      this.controlMonitorVisible = false;
      this.currentAd = null;
    },
    // 追投关停操作变更
    handleZtgtChange(e) {
      this.warnCondition.ztgt_json.action = e;
    },
    // 高产复投预算变更
    handleGcftBudgetChange(e) {
      this.warnCondition.gcft_json.budget = e.target.value;
    },
    // 高产复投时长减少
    onGcftDurationDrop() {
      let duration = parseFloat(this.warnCondition.gcft_json.duration);
      if (duration < 0.5) {
        this.warnCondition.gcft_json.duration = '0';
        this.$message.warning('调控时长不能低于0小时');
        return;
      } else {
        this.warnCondition.gcft_json.duration = duration - 0.5;
      }
    },
    // 高产复投时长增加
    onGcftDurationRise() {
      let duration = parseFloat(this.warnCondition.gcft_json.duration);
      if (duration > 24) {
        this.warnCondition.gcft_json.duration = 24;
        this.$message.warning('调控时长最大只能24小时');
      } else {
        this.warnCondition.gcft_json.duration = duration + 0.5;
      }
    },
    // 验证ROI输入格式
    validateRoiInput(value) {
      if (value && !isNumber(value)) {
        this.$message.warning('请输入有效的数字');
        return false;
      }
      return true;
    },
    // 验证消耗输入格式
    validateCostInput(value) {
      if (value && !isNumber(value)) {
        this.$message.warning('请输入有效的数字');
        return false;
      }
      if (value && parseFloat(value) < 0) {
        this.$message.warning('消耗不能为负数');
        return false;
      }
      return true;
    },
    // 格式化数值显示
    formatNumber(value, decimals = 2) {
      if (!value) return '';
      const num = parseFloat(value);
      if (isNaN(num)) return value;
      return num.toFixed(decimals);
    },
    /** 回填 / 初始化 gcft_json 中多时段不同配置的 slot_configs */
    normalizeGcftSlotConfigs(g) {
      if (!g || typeof g !== 'object') return;
      const tt = String(g.tk_config_time != null ? g.tk_config_time : '1');
      this.$set(g, 'tk_config_time', tt);
      if (tt !== '2') {
        if (!Array.isArray(g.slot_configs)) this.$set(g, 'slot_configs', []);
        return;
      }
      let slots = Array.isArray(g.slot_configs) ? [...g.slot_configs] : [];
      if (slots.length === 0) {
        const times =
          Array.isArray(g.times) && g.times.length > 0 ? g.times : ['00:00'];
        const duration =
          g.duration != null ? String(g.duration) : '12';
        const budget = g.budget != null ? String(g.budget) : '100';
        const diyamount =
          g.diyamount != null ? String(g.diyamount) : '';
        slots = times.map((time) => ({
          time: time || '00:00',
          duration,
          budget,
          diyamount: diyamount || '',
        }));
      } else {
        slots = slots.map((s) => ({
          time: s.time || '00:00',
          duration: String(s.duration != null ? s.duration : '12'),
          budget: String(s.budget != null ? s.budget : '100'),
          diyamount: s.diyamount != null ? String(s.diyamount) : '',
        }));
      }
      this.$set(g, 'slot_configs', slots);
    },
    onGcftTkConfigTimeChange() {
      this.$nextTick(() => {
        const v = String(this.warnCondition.gcft_json.tk_config_time);
        if (v === '2') {
          this.syncGcftMode2FromMode1();
        } else {
          this.syncGcftMode1FromMode2();
        }
      });
    },
    syncGcftMode2FromMode1() {
      const g = this.warnCondition.gcft_json;
      const times =
        Array.isArray(g.times) && g.times.length > 0 ? [...g.times] : ['00:00'];
      const duration = g.duration != null ? String(g.duration) : '12';
      const budget = g.budget != null ? String(g.budget) : '100';
      const diyamount = g.diyamount != null ? String(g.diyamount) : '';
      const slots = times.map((t) => ({
        time: t || '00:00',
        duration,
        budget,
        diyamount: diyamount || '',
      }));
      this.$set(g, 'slot_configs', slots);
    },
    syncGcftMode1FromMode2() {
      const g = this.warnCondition.gcft_json;
      const slots = Array.isArray(g.slot_configs) ? g.slot_configs : [];
      if (!slots.length) return;
      this.$set(
        g,
        'times',
        slots.map((s) => s.time || '00:00')
      );
      const f0 = slots[0];
      this.$set(g, 'duration', String(f0.duration != null ? f0.duration : '12'));
      this.$set(g, 'budget', String(f0.budget != null ? f0.budget : '100'));
      this.$set(
        g,
        'diyamount',
        f0.diyamount != null ? String(f0.diyamount) : ''
      );
    },
    addGcftSlotConfig() {
      const g = this.warnCondition.gcft_json;
      if (!Array.isArray(g.slot_configs)) this.$set(g, 'slot_configs', []);
      if (g.slot_configs.length >= 10) {
        this.$message.warning('最多添加10个时段');
        return;
      }
      const last = g.slot_configs[g.slot_configs.length - 1];
      const baseTime = last ? last.time : '00:00';
      let newTime = moment(baseTime, 'HH:mm').add(1, 'hour').format('HH:mm');
      if (g.slot_configs.some((s) => s.time === newTime)) {
        newTime = moment().add(1, 'hour').startOf('hour').format('HH:mm');
      }
      g.slot_configs.push({
        time: newTime,
        duration: last ? String(last.duration) : '12',
        budget: last ? String(last.budget) : '100',
        diyamount: last && last.diyamount != null ? String(last.diyamount) : '',
      });
    },
    removeGcftSlotConfig(index) {
      const slots = this.warnCondition.gcft_json.slot_configs;
      if (!slots || slots.length <= 1) {
        this.$message.warning('至少需要保留一个时段');
        return;
      }
      slots.splice(index, 1);
    },
    onGcftSlotTimeChange(timeString, index) {
      const slots = this.warnCondition.gcft_json.slot_configs;
      if (!slots || !slots[index]) return;
      const duplicate = slots.findIndex(
        (s, i) => i !== index && s.time === timeString
      );
      if (duplicate !== -1) {
        this.$message.warning('该时间段已存在，请选择其他时间');
        return;
      }
      this.$set(slots[index], 'time', timeString);
    },
    onGcftSlotDurationInput(index, raw) {
      const slots = this.warnCondition.gcft_json.slot_configs;
      if (!slots || !slots[index]) return;
      let n = parseFloat(raw);
      if (isNaN(n)) {
        this.$set(slots[index], 'duration', String(raw));
        return;
      }
      if (n < 0.5) n = 0.5;
      if (n > 24) n = 24;
      this.$set(slots[index], 'duration', String(n));
    },
    onGcftSlotDurationDrop(index) {
      const slots = this.warnCondition.gcft_json.slot_configs;
      if (!slots || !slots[index]) return;
      let duration = parseFloat(slots[index].duration);
      if (isNaN(duration)) duration = 12;
      if (duration < 0.5) {
        this.$set(slots[index], 'duration', '0.5');
        this.$message.warning('追加时长不能低于0.5小时');
        return;
      }
      this.$set(slots[index], 'duration', String(duration - 0.5));
    },
    onGcftSlotDurationRise(index) {
      const slots = this.warnCondition.gcft_json.slot_configs;
      if (!slots || !slots[index]) return;
      let duration = parseFloat(slots[index].duration);
      if (isNaN(duration)) duration = 12;
      if (duration > 24) {
        this.$set(slots[index], 'duration', '24');
        this.$message.warning('追加时长最大只能24小时');
      } else {
        this.$set(slots[index], 'duration', String(duration + 0.5));
      }
    },
    handleGcftSlotBudgetChange(e, index) {
      const slots = this.warnCondition.gcft_json.slot_configs;
      if (!slots || !slots[index]) return;
      this.$set(slots[index], 'budget', e.target.value);
    },
    gcftSlotDiyNumber(val) {
      const n = parseFloat(val);
      return Number.isFinite(n) ? n : undefined;
    },
    onGcftSlotDiyChange(index, v) {
      const slots = this.warnCondition.gcft_json.slot_configs;
      if (!slots || !slots[index]) return;
      this.$set(
        slots[index],
        'diyamount',
        v != null && v !== '' ? String(v) : ''
      );
    },
    // 多时段时间变化处理
    onMultiTimeChange(timeString, index, pz) {
      if (this.warnCondition[pz] && this.warnCondition[pz].times) {
        // 检查时间是否重复
        const duplicateIndex = this.warnCondition[pz].times.findIndex(
          (t, i) => t === timeString && i !== index
        );
        if (duplicateIndex !== -1) {
          this.$message.warning('该时间段已存在，请选择其他时间');
          return;
        }
        this.$set(this.warnCondition[pz].times, index, timeString);
      }
    },
    // 添加多时段
    addMultiTime(pz) {
      if (!this.warnCondition[pz].times) {
        this.$set(this.warnCondition[pz], 'times', []);
      }
      // 默认添加时间为当前时间的下一个整点
      const now = moment();
      const nextHour = moment(now).add(1, 'hour').startOf('hour');
      const defaultTime = nextHour.format('HH:mm');
      // 检查时间是否重复
      if (this.warnCondition[pz].times.includes(defaultTime)) {
        // 如果重复，尝试下一个整点
        const nextNextHour = moment(now).add(2, 'hour').startOf('hour');
        const altTime = nextNextHour.format('HH:mm');
        if (!this.warnCondition[pz].times.includes(altTime)) {
          this.warnCondition[pz].times.push(altTime);
        } else {
          // 如果还是重复，使用最后一个时间段加1小时
          const lastTime = this.warnCondition[pz].times[this.warnCondition[pz].times.length - 1];
          const lastMoment = moment(lastTime, 'HH:mm');
          const newTime = moment(lastMoment).add(1, 'hour').format('HH:mm');
          this.warnCondition[pz].times.push(newTime);
        }
      } else {
        this.warnCondition[pz].times.push(defaultTime);
      }
    },
    // 删除多时段
    removeMultiTime(index, pz) {
      if (this.warnCondition[pz] && this.warnCondition[pz].times) {
        if (this.warnCondition[pz].times.length <= 1) {
          this.$message.warning('至少需要保留一个时段');
          return;
        }
        this.warnCondition[pz].times.splice(index, 1);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.extra-wrapper {
  position: absolute;
  right: 0px;
}

.ant-card-head-wrapper {
  text-align: left !important;
  font-weight: bold !important;
  color: #000;
}

.widget-1 {
  display: flex;

  .ant-statistic-content {
    font-family: open sans, Helvetica, Arial, sans-serif;
    font-weight: 700;
    color: inherit;
    font-size: 30px;
    line-height: 30px;
    text-align: center;
    margin: 10px auto;
  }

  .icon {
    width: 48px;
    height: 48px;
    position: absolute;
    right: 16px;
    margin: auto;
    background-color: #1890ff;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.12);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.ant-tabs-tab {
  font-weight: bold !important;
}

.extra-item {
  display: inline-block;
  margin-right: 24px;

  a {
    margin-left: 24px;
    color: #666;
    font-weight: bold;
  }

  .selected {
    color: #1890ff;
  }
}

.searchResult {
  .name {
    color: #333;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
  }
}

.aweme {
  display: flex;
}

.aweme-right {
  text-align: left;

  .aweme-title {
    color: #323335;
    font-weight: bold;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 180px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    height: 45px;
  }
}

.small {
  font-size: 11px;
  line-height: 18px;
}

.tips {
  margin-bottom: 10px;
}

.showTemplate {
  .dataOverview {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 0;
  }

  .dataViewItem {
    flex: 1;
    margin-right: 0.5%;
    margin-left: 0.5%;
    border-radius: 15px;
    float: left;
    box-shadow: 0 2px 8px #00000026;
    margin-bottom: 10px;
    overflow: hidden;
    height: 120px;

    div {
      text-align: left;
      color: #333;
      font-size: 18px;
      padding-top: 20px;
      padding-left: 20px;
    }

    p {
      font-size: 24px;
      padding-top: 5px;
      font-weight: bold;
    }
  }
}

.copy-icon {
  height: 100px;
  border-radius: 5px;
  cursor: pointer;
}

.rowOperate {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  line-height: 30px;

  .actionItem {
    margin-left: 10px;
    color: #597ef7;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }
}

.filterCondition {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  span {
    margin-left: 20px;
  }
}

.tags-container {
  padding: 16px 0px;
  overflow: hidden;
}

.tags-container .ad-tag {
  float: left;
  margin-left: 16px;
}

.tags-container .ad-tag:first-child {
  margin-left: 0;
}

.tags-container .inbl {
  display: inline-block;
  vertical-align: middle;
}

.tags-container .roi-input {
  position: relative;
  top: 1px;
}

.tags-container .roi-target-box {
  display: inline-block;
  margin-left: 24px;
}

.tags-container .info-item {
  float: left;
  height: 26px;
  position: relative;
}

.avatar {
  widows: 26px;
  height: 26px;
  border-radius: 50%;
  margin-right: 5px;
}

.tags-container .info-item.editable {
  padding-right: 28px;
}

.tags-container .info-item .content {
  display: inline-block;
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tags-container .info-item .content .nobid-bid-content {
  color: #999;
}

.tag {
  background: #f2f2f2;
  border-radius: 4px;
  color: #999;
  font-size: 14px;
  line-height: 22px;
  padding: 2px 8px;
}

.tag.red {
  background: #fff1ef;
  color: #e5453f;
}

.tag.gray {
  background: #f2f2f2;
  color: #999;
}

.tag.green {
  background: #e6f8ee;
  color: #34ba7b;
}

.copynum {
  font-weight: bold;
  color: red;
}

.product-item {
  display: flex;
  height: 56px;
  margin-top: 8px;
}

.product-item .good {
  padding-left: 0;
}

.product-item .icon {
  border-radius: 4px;
  height: 56px;
  width: 56px;
}

.product-item .info {
  padding-top: 3px;
}

.product-item .info .name {
  font-size: 14px;
  height: 22px;
  line-height: 22px;
  margin: 0 0 8px 16px;
}

.product-item .info .id,
.product-item .info .price {
  color: #999;
  display: inline-block;
  font-size: 12px;
  line-height: 20px;
  padding: 0 16px;
}

.product-item .info .separator {
  border-right: 1px solid #999;
  display: inline-block;
  height: 8px;
  position: relative;
}

.product-item .info .price-num {
  color: #333;
  margin-left: 8px;
}

.ad-drawer__aweme-info {
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 16px;
}

.title {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  line-height: 34px;
}

.board-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 21px;
  min-width: 932px;

  .overview-board {
    background: #f2f2f2;
    background-color: #f2f2f2;
    margin: 0 10px 10px 0;
    border-radius: 8px;
    cursor: pointer;
    height: 108px;
    width: 175px;

    .inner {
      border-radius: 4px;
      padding: 12px 12px 17px;

      .metric {
        color: #252729;
        font-size: 14px;
        font-weight: 600;
        height: 20px;
        line-height: 20px;
        margin: 0;
      }

      .value {
        font-size: 20px;
        margin-top: 8px;
        font-weight: bold;
        color: rgb(51, 51, 51);
      }
    }
  }
}

.setting-item {
  display: flex;
  font-size: 14px;
  line-height: 20px;
  min-height: 44px;
  padding: 12px 16px;
  width: 50%;
  float: left;

  label {
    color: #333;
    flex-shrink: 0;
    font-weight: bold;
    margin-right: 24px;
    width: 80px;
  }

  .display-value {
    color: #333;
    flex: 1 1;
  }
}

.footer {
  position: fixed;
  bottom: 0px;
  background: #fff;
  height: 80px;
  width: 940px;
  line-height: 80px;
  border-top: 1px solid #eee;

  button {
    margin-right: 10px;
  }
}

.videoimg {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  cursor: pointer;
  margin-left: 10px;
  margin-right: 10px;
}

.dialog-left {
  width: 180px;
  float: left;
  padding-top: 20px;
  height: 100%;
  border-right: 1px solid #e5e5e5;
}

.dialog-left ul li {
  margin: 0 auto;
  line-height: 40px;
  font-size: 16px;
  color: #2d3035;
  width: 130px;
  height: 40px;
  border-radius: 3px;
  margin-bottom: 10px;
  text-align: left;
  cursor: pointer;
}

.dialog-center {
  width: 620px;
  float: left;
  padding: 10px 20px;
  color: #242a37;

  ul {
    padding: 0;
    margin: 0;
  }
}

.dialog-right {
  width: 190px;
  float: left;
  padding: 10px;
  color: #939cc0;
  height: 340px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-track-color: transparent;
  -ms-scrollbar-track-color: transparent;
  scrollbar-width: thin;
  border-left: 1px solid #e5e5e5;
}

.dialog-center-title {
  font-size: 16px;
  margin-bottom: 10px;
}

li {
  list-style: none;
}

.dialog-right ul li {
  margin: 0 auto;
  line-height: 30px;
  font-size: 14px;
  color: #13151a;
  width: 184;
  height: 30px;
  border-radius: 3px;
  margin-bottom: 10px;
  text-align: left;
  padding-left: 10px;
  cursor: pointer;
  background: #f2f2f2;
  position: relative;
}

.dialog-right ul li span {
  float: right;
  margin-right: 10px;
}

.dialog-center ul li {
  width: 25%;
  margin-bottom: 10px;
  float: left;
}

.dialog-right ul {
  margin: 0;
  padding: 0;
}

.yAxis {
  display: flex;
  align-items: center;
  justify-content: center;

  input {
    width: 145px;
    border-radius: 5px;
  }

  & > div {
    display: flex;
    align-items: center;
  }

  section {
    width: 13px;
    height: 12px;
    background: #ff4d4f;
    border-radius: 3px;
    margin-right: 10px;
  }

  & > div:nth-child(1) {
    margin-right: 35px;

    section {
      background-color: #1890ff;
    }
  }
}

.yAxis + .totops {
  height: 0;
  opacity: 0;
}

/* 在你的CSS文件或<style>标签中添加以下样式 */
/deep/ .ant-table-tbody > tr > td {
  padding: 8px;
}

/deep/ .ant-table-thead > tr > th {
  padding: 8px;
}

// css

.ant-card {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03),
    0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 1.5714285714285714;
  list-style: none;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  position: relative;
  background: #ffffff;
  border-radius: 8px;
  border-top: 1px solid #efefef;
}

.acss-14lc1cu {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.acss-1fpsglh {
  margin-top: 8px;
  padding-top: 9px;
  border-top: 1px solid rgba(5, 5, 5, 0.06);
}

.acss-grxbm {
  position: relative;
  width: 100%;
  margin-bottom: 12px;
}

.acss-eji7bv {
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}

.acss-1x0bxe0 {
  font-size: 14px;
  line-height: 22px;
}

.acss-72p16p {
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.88);
}

.acss-qdes8r {
  position: relative;
  top: 4px;
  float: left;
  margin-right: 20px;
}

.acss-1odwksc {
  float: left;
}

.acss-1qoci3j {
  height: 22px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 22px;
}

.acss-18kfphl {
  position: absolute;
  top: 4px;
  right: 0;
  line-height: 1;
  cursor: pointer;
}

.acss-f1zikh {
  height: 38px;
  margin-top: 4px;
  margin-bottom: 0;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.88);
  font-size: 30px;
  line-height: 38px;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
}

.acss-16mkun2 {
  margin-top: 10px;
}

.totalItem {
  text-align: left;

  b {
    margin-right: 30px;
  }
}

/deep/ .ant-checkbox + span {
  padding-left: 2px;
}

.ant-switch {
  margin-left: 20px;
}
.ant-modal-body {
  padding: 10px 24px;
}
.confBlock {
  background: #fff;
  margin-bottom: 12px;
  border-radius: 4px;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.2);
  padding: 16px 24px;
  .cofBlockName {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &::before {
      content: '';
      width: 4px;
      height: 14px;
      background-color: #2b6afd;
      margin-right: 8px;
      display: inline-block;
    }
  }
  .confContent {
    margin-top: 20px;
  }
  .confLine {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
    &.fxStart {
      align-items: flex-start;
      .confLable {
        margin-top: 6px;
      }
    }
    .confLable {
      width: 90px;
      text-align: right;
      margin: 0px 10px 0 0;
    }
    .hintBlock {
      margin-top: 8px;
      font-size: 12px;
    }
    .conditionInput {
      width: 120px;
      margin-right: 10px;
    }
    .actionCondition {
      margin-bottom: 8px;
    }
  }
}

.title-box {
  line-height: 40px;
}

.ant-switch {
  margin-left: 20px;
}
.ant-modal-body {
  padding: 10px 24px;
}

// 高产复投特定样式
.gcft-config {
  .conditionInput {
    width: 120px;
    margin-right: 10px;
  }

  .budget-options {
    margin-top: 8px;
  }

  .duration-control {
    display: flex;
    align-items: center;
    margin-top: 8px;
  }
}

.diy-material-config {
  .diy-rule-card {
    margin-bottom: 16px;
    padding: 12px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    background: #fafafa;
  }

  .diy-rule-card__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .diy-rule-card__title {
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }

  .diy-rule-card__delete {
    color: #ff4d4f;
    cursor: pointer;
    font-size: 16px;
  }
}
</style>
